// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
/** Error codes the service throws via AppError. */
export const PDPL_EMAIL_DRAFT_ERROR_CODES = {
    PACK_NOT_FOUND: 'PDPL_EMAIL_DRAFT_PACK_NOT_FOUND',
    DRAFT_NOT_FOUND: 'PDPL_EMAIL_DRAFT_NOT_FOUND',
    INVALID_LOCALE: 'PDPL_EMAIL_DRAFT_INVALID_LOCALE',
    INVALID_PROOF_FILE: 'PDPL_EMAIL_DRAFT_INVALID_PROOF_FILE',
    COVER_LETTER_RENDER_FAILED: 'PDPL_EMAIL_DRAFT_COVER_LETTER_RENDER_FAILED',
    NO_CHANGES: 'PDPL_EMAIL_DRAFT_NO_CHANGES',
};
/** Verbatim NQ22 disclaimer text. Kept here so backend + future frontend
 *  preview share the same source of truth. EN + VI are NOT translations of
 *  each other in the legal-text sense — both are authoritative and the
 *  draft body carries both blocks when locale is `en` (with VI underneath)
 *  or `vi` (with EN underneath). Service decides ordering by locale. */
export const PDPL_EMAIL_UNOFFICIAL_CHANNEL_DISCLAIMER = {
    en: 'This email is sent under the NQ22/2026 administrative-simplification window. Email is NOT a NQ22 official channel — this is a practical accommodation pending the National Public Service Portal acceptance of the 8-part ZIP layout. Please confirm receipt and acceptable handling with the MoPS A05 contact on file. Hard-copy follow-up may be required.',
    vi: 'Email này được gửi trong khuôn khổ chuyển tiếp đơn giản hóa thủ tục hành chính NQ22/2026. Email KHÔNG phải là kênh chính thức theo NQ22 — đây là sự sắp xếp thực tiễn trong khi chờ Cổng dịch vụ công quốc gia chấp nhận bố cục ZIP 8 phần. Vui lòng xác nhận đã nhận và phương thức xử lý phù hợp với liên hệ Bộ Công an A05 đang được sử dụng. Có thể yêu cầu nộp bổ sung bản giấy.',
};
//# sourceMappingURL=pdpl-email-draft.js.map